import React from 'react';
import { useNavigate } from 'react-router-dom';

const PageNotFound = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
        <h1 className="text-4xl font-bold text-red-500 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">ページが見つかりません</h2>
        <p className="text-gray-600 mb-6">
          お探しのページは存在しないか、移動した可能性があります。
        </p>
        <div className="flex justify-center">
          <button
            onClick={goToHome}
            className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-lg transition duration-300"
          >
            ホームに戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound; 